import React, { useEffect, useState, useCallback, useMemo } from 'react';
import ClubLocker from '../../components/locker/ClubLocker';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadClubLocker,
  removeUserLocker,
} from '../../modules/member/locker';
import { withRouter } from 'react-router-dom';
import CreateLockerModal from '../../components/locker/CreateLockerModal';
import {
  changeCreateForm,
  createLocker,
  initialize,
  initializeRes,
  setLockerBlock,
  deleteLocker,
  unreadSelectBLock,
  updateLocker,
} from '../../modules/locker/clubLocker';
import { inputNumberRemoveComma, hasEmoji } from '../../lib/commonFunc/commonFunc';
import AskRemoveModal from '../../components/common/AskRemoveModal';

const ClubLockerContainer = ({ history }) => {
  const dispatch = useDispatch();
  const [modals, setMdoals] = useState([
    { id: 1, value: 'locker', visible: false },
    { id: 2, value: 'lockerSN', visible: false },
    { id: 3, value: 'remove', visible: false },
    { id: 4, value: 'expire', visible: false },
  ]);
  const [isEdit, toggleEdit] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const {
    lockers,
    loading,
    club,
    socketKey,
    form,
    _modalRes,
    removeRes,
  } = useSelector(({ loading, locker, club, socket, clubLocker }) => ({
    lockers: locker.club,
    userLocker: locker.user,
    club: club.defaultClub,
    loading: loading['locker/LOAD_CLUBLOCKER'],
    socketKey: socket.socketKey,
    form: clubLocker,
    _modalRes: clubLocker.editRes,
    removeRes: locker.removeRes,
  }));

  if(lockers) {
    console.log('lockers : ', lockers[0])
  }

  const onOpenModal = (modalID, locker) => {
    if (!locker) {
      // 신규 생성 시 폼 초기화
      dispatch(initialize());
      dispatch(unreadSelectBLock());
    }
    if (locker) {
      dispatch(setLockerBlock(locker));
    }
    setMdoals(
      modals.map((modal) =>
        modal.id === modalID ? { ...modal, visible: true } : modal,
      ),
    );
  };

  const onChangeField = (e) => {
    let { name, value } = e.target;
    const commaStr = ['price', 'card', 'cash', 'point', 'pay', 'salePrice', 'lockerSN', 'startSN', 'endSN'];

    if (commaStr.some((el) => el.includes(name))) {
      value = inputNumberRemoveComma(value);
    }
    dispatch(
      changeCreateForm({
        key: name,
        value,
      }),
    );
  };

  const onCreateLocker = () => {
    const { name, card, cash, point, pay, price, salePrice, startSN, endSN } = form;
    
    // 시작 번호 검증
    const startNumber = parseInt(startSN) || 0;
    const endNumber = parseInt(endSN) || 0;
    
    if (!startNumber || startNumber < 1) {
      alert('시작 번호를 1 이상으로 입력해주세요.');
      return false;
    }
    
    if (!endNumber || endNumber < 1) {
      alert('끝 번호를 1 이상으로 입력해주세요.');
      return false;
    }
    
    if (endNumber < startNumber) {
      alert('끝 번호는 시작 번호보다 크거나 같아야 합니다.');
      return false;
    }
    
    const count = endNumber - startNumber + 1;
    
    if (count > 9999) {
      alert('9999개 이하로 생성 가능합니다.');
      return false;
    }

    // utf8mb3 DB 는 이모지(4바이트 문자)를 저장할 수 없어 등록을 차단한다
    if (hasEmoji(name)) {
      alert('이모지를 사용할 수 없습니다.');
      return false;
    }

    const nextType =
      lockers.reduce((previous, current) => {
        return previous.type > current.type
          ? previous.lockerID
          : current.lockerID;
      }, 0) + 1;
    let maxID = lockers.reduce((previous, current) => {
      return previous.lockerID > current.lockerID
        ? previous.lockerID
        : current.lockerID;
    }, 0);

    maxID = maxID == 0?0:maxID+1;
    
    const lockerList = [];
    for (let i = 0; i < count; i++) {
      let locker = {
        lockerID: maxID + i,
        lockerSN: startNumber + i,
        playerID: 0,
        playerImage: '',
        playerName: '',
        name: name,
        card,
        cash,
        point,
        pay,
        price,
        salePrice,
        holdList: [],
        controlList: [],
        startTime: 0,
        endTime: 0,
        state: 0,
        type: nextType,
        subsID: ""
      };
      lockerList.push(locker);
    }

    dispatch(
      createLocker({
        lockerList,
        socketKey,
        clubID: club.clubID,
      }),
    );
    setMdoals(
      modals.map((modal) =>
        modal.id === 1 ? { ...modal, visible: false } : modal,
      ),
    );
  };

  const onCloseModal = (modalID) => {
    setMdoals(
      modals.map((modal) =>
        modal.id === modalID ? { ...modal, visible: false } : modal,
      ),
    );
  };

  const onSale = (locker) => {
    const { lockerID, lockerSN, type, name, startTime, endTime, card, cash, point, pay, price, salePrice } = locker;
    history.push(
      `/locker/sale?lockerID=${lockerID}&lockerSN=${lockerSN}&type=${type}&name=${name}&startTime=${startTime}&endTime=${endTime}&card=${card}&cash=${cash}&point=${point}&pay=${pay}&price=${price}&salePrice=${salePrice}`,
    );
  };

  //이미 존재하는 락커에서 수정버튼 눌렀을때(락커블락안의 락커 총개수,이름 수정)
  const onModifyLocker = useCallback(() => {
    const {
      name,
      card,
      cash,
      point,
      pay,
      price,
      salePrice,
      selectBlock,
      startSN,
      endSN,
    } = form;

    if (!selectBlock || selectBlock.length === 0) {
      alert('편집할 락커 정보를 찾을 수 없습니다.');
      return false;
    }

    // utf8mb3 DB 는 이모지(4바이트 문자)를 저장할 수 없어 수정을 차단한다
    if (hasEmoji(name)) {
      alert('이모지를 사용할 수 없습니다.');
      return false;
    }

    const sortedBlock = [...selectBlock].sort(
      (prev, next) => prev.lockerSN - next.lockerSN,
    );

    // 시작 번호와 끝 번호 검증
    const startNumber = parseInt(startSN, 10) || 0;
    const endNumber = parseInt(endSN, 10) || 0;

    if (!startNumber || startNumber < 1) {
      alert('시작 번호를 1 이상으로 입력해주세요.');
      return false;
    }

    if (!endNumber || endNumber < 1) {
      alert('끝 번호를 1 이상으로 입력해주세요.');
      return false;
    }

    if (endNumber < startNumber) {
      alert('끝 번호는 시작 번호보다 크거나 같아야 합니다.');
      return false;
    }

    const desiredCount = endNumber - startNumber + 1;

    if (desiredCount > 9999) {
      alert('9999개 이하로 생성 가능합니다.');
      return false;
    }

    const targetSNs = [];
    for (let sn = startNumber; sn <= endNumber; sn++) {
      targetSNs.push(sn);
    }
    const targetSNSets = new Set(targetSNs);

    const existingMap = new Map();
    sortedBlock.forEach((locker) => {
      existingMap.set(locker.lockerSN, locker);
    });

    const lockersToDelete = sortedBlock.filter((locker) => !targetSNSets.has(locker.lockerSN));
    const hasInUseLocker = lockersToDelete.some((locker) => locker.state === 1 || locker.playerID);
    if (hasInUseLocker) {
      alert('사용 중인 락커가 있어 범위를 줄일 수 없습니다.');
      return false;
    }

    const lockersToUpdate = targetSNs
      .filter((sn) => existingMap.has(sn))
      .map((sn) => {
        const locker = existingMap.get(sn);
        return {
          ...locker,
          lockerSN: sn,
          name,
          card,
          cash,
          point,
          pay,
          price,
          salePrice,
        };
      });

    const lockerCollection = Array.isArray(lockers) ? lockers : [];

    const missingSNs = targetSNs.filter((sn) => !existingMap.has(sn));
    if (missingSNs.length > 0) {
      const maxLockerID = lockerCollection.reduce(
        (previous, current) =>
          previous.lockerID > current.lockerID ? previous.lockerID : current.lockerID,
        0,
      );
      const baseLockerID = maxLockerID === 0 ? 0 : maxLockerID + 1;

      const lockerList = missingSNs.map((sn, index) => ({
        lockerID: baseLockerID + index,
        lockerSN: sn,
        playerID: 0,
        playerImage: '',
        playerName: '',
        name,
        card,
        cash,
        point,
        pay,
        price,
        salePrice,
        holdList: [],
        controlList: [],
        startTime: 0,
        endTime: 0,
        state: 0,
        type: sortedBlock[0]?.type || 0,
        subsID: '',
      }));

      if (lockerList.length) {
        dispatch(
          createLocker({
            lockerList,
            socketKey,
            clubID: club.clubID,
          }),
        );
      }
    }

    if (lockersToUpdate.length) {
      dispatch(
        updateLocker({
          socketKey,
          locker: lockersToUpdate,
          clubID: club.clubID,
        }),
      );
    }

    if (lockersToDelete.length) {
      const removeTargets = lockersToDelete.map((locker) => locker.lockerID);
      dispatch(
        deleteLocker({
          socketKey,
          clubID: club.clubID,
          lockerlist: removeTargets,
        }),
      );
    }
    onCloseModal(1);
  }, [form, dispatch, lockers, socketKey, club, onCloseModal]);

  const onRemove = (locker) => {
    dispatch(setLockerBlock(locker));
  };

  const onConfirm = () => {
    const { selectBlock } = form;
    if (isNaN(form.count)) {
      alert('1 이상의 올바른 숫자를 입력해주세요.');
      return false;
    }

    if (parseInt(form.count) < 1) {
      alert('락커 개수는 1개 이상이어야합니다');
      return false;
    }
    const isSaled = selectBlock.some((locker) => locker.state === 1);
    if (isSaled) {
      alert('사용 중인 락커가 있습니다. 락커를 모두 비운 후에 시도하세요');
      return false;
    }
    const lockerlist = selectBlock.map((locker) => locker.lockerID);
    dispatch(
      deleteLocker({
        clubID: club.clubID,
        socketKey,
        lockerlist,
      }),
    );
    onCloseModal(3);
  };

  const onExpireLocker = () => {
    const { selectBlock } = form;

    const saledLocker = {
      ...selectBlock,
      playerName: '',
      startTime: 0,
      endTime: 0,
      playerID: 0,
      state: 0,
    };
    dispatch(
      removeUserLocker({ locker: saledLocker, socketKey, clubID: club.clubID }),
    );

    onCloseModal(4);
  };

  const onEdit = () => {
    if (isEdit) {
      toggleEdit(false);
    } else {
      toggleEdit(true);
    }
  };

  const onMouseOver = (locker) => {};

  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);
  useEffect(() => {
    if (club) {
      dispatch(loadClubLocker({ socketKey, clubID: club.clubID }));
    }
  }, [club, dispatch, socketKey, _modalRes]);

  useEffect(() => {
    if (_modalRes === 20000) {
      alert('에러가 발생했습니다. 다시 로그인해 주세요.');
      history.push('/login');
      dispatch(initializeRes());
    } else if (_modalRes && _modalRes.result !== 1) {
      //alert('락커 생성에 실패했습니다. 잠시 후 다시 시도해주세요.');
    }
  }, [_modalRes, dispatch, history]);

  useEffect(() => {
    if (removeRes) {
      dispatch(loadClubLocker({ socketKey, clubID: club.clubID }));
    }
  }, [removeRes]);

  // 락커 검색: 이름(playerName) 기준
  const filteredLockers = useMemo(() => {
    if (!Array.isArray(lockers) || !searchKeyword.trim()) return lockers || [];
    const keyword = searchKeyword.trim().toLowerCase();
    return lockers.filter((locker) =>
      (locker.playerName || '').toLowerCase().includes(keyword),
    );
  }, [lockers, searchKeyword]);

  return (
    <>
      <ClubLocker
        loading={loading}
        lockers={filteredLockers}
        searchKeyword={searchKeyword}
        onSearchChange={setSearchKeyword}
        onOpenModal={onOpenModal}
        onSale={onSale}
        onModifyLocker={onModifyLocker}
        onRemove={onRemove}
        onEdit={onEdit}
        isEdit={isEdit}
        onMouseOver={onMouseOver}
        totalCount={Array.isArray(lockers) ? lockers.length : 0}
        filteredCount={Array.isArray(filteredLockers) ? filteredLockers.length : 0}
      />
      <CreateLockerModal
        visible={modals[0].visible}
        onCloseModal={onCloseModal}
        onCreateLocker={onCreateLocker}
        onModifyLocker={onModifyLocker}
        onChangeField={onChangeField}
        form={form}
        modalIndex={1}
      />

      <AskRemoveModal
        visible={modals[2].visible}
        text="락커"
        onConfirm={onConfirm}
        onCancel={() => onCloseModal(3)}
        lockerInfo={form}
      />
      <AskRemoveModal
        visible={modals[3].visible}
        text="락커"
        onConfirm={onExpireLocker}
        onCancel={() => onCloseModal(4)}
        lockerInfo={form}
        expire
      />
    </>
  );
};

export default withRouter(ClubLockerContainer);
